import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { EvaluadorComponent } from './evaluador.component';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
const rutas: Routes = [
  {
      path     : 'evaluador',
      component: EvaluadorComponent,
      canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [EvaluadorComponent],
  imports: [
    CommonModule,
    MatIconModule,
    FlexLayoutModule,
    TranslateModule,
    RouterModule.forChild(rutas)
  ]
})
export class EvaluadorModule { }